export default __webpack_public_path__ + "static/media/ministarstvoBih.1a3fd5cd.png";